<template>
    <div style="padding:20px;text-align: left;">
        <div style="background: #fff;padding:20px">        
      <div style="font-weight: 600;display: flex;justify-content: space-between;">
        <span>协作续传</span>
        <a :href="'/xiezuophoto?key='+secretkey"><el-button size="small" style="border-radius: 4px;" type="primary">去编辑图片<i class="el-icon-right"></i></el-button></a>
      </div>
        <div style="margin:20px 0px;font-size: 22px;font-weight: 600;">
            {{ zuzhaotitle }}
        </div>
        <div>
            <el-row :gutter="20">
   
            </el-row>
            <el-row style="margin-top:20px">
                <el-col :span="24">
                    <div style="border: 1px solid #eeeeee;width: 100%;min-height: 400px;">
                        <div style="padding:8px 15px;border-bottom: 1px solid #eeeeee;font-weight: 600;">
                            续传
                        </div>
                        <div style="padding:8px 15px;font-size: 12px;display: flex;align-items: center;">
                            <span style="color:#aaaaaa;font-size: 12px;margin-right: 20px;">上传文件前请先选择标签</span>
                            <el-checkbox-group v-model="selbiaoqian" @change="xzbiaoqian">
                                <el-checkbox v-for="item in biaoqianlist" :key="item.id" :label="item.id">
                                    <span style="color:#aaaaaa;font-size: 12px;">{{ item.labelname
                                    }}</span></el-checkbox>

                            </el-checkbox-group>
                        </div>
                        <div style="padding:8px 15px">
                            <div style="display: flex;">
                                <el-upload class="upload-demo"
                                    :data="{ collection_id: zuzhaoid, share_label_id: share_label_id, in_id: in_id }"
                                    action="https://interface.luchuaner.com/shangchuantupian" :show-file-list="false"
                                    :on-change="handleChange" :on-preview="handlePreview"
                                    :on-success="handleAvatarSuccesstp" :before-upload="beforeAvatarUpload" multiple 
                                    accept="image/*"
                                    >
                                    <el-button size="small" type="primary" style="border-radius: 4px;">选择图片</el-button>

                                </el-upload>
                                <uploadvideo :in_id="Number(in_id)" :collection_id="Number(zuzhaoid)" />
                            </div>
                            <div slot="tip" class="el-upload__tip" style="color:#aaaaaa;line-height: 20px;">
                                1.单张图片最大支持15MB，单个视频最大支持1GB<br />
                                2.网速欠佳时，请少量多次上传<br />
                                3.挂机上传时，电脑休眠可能造成上传中断，尽量时不时动动电脑直到传输结束<br />
                                4.使用SAFARI和IE上传，可能会出现卡顿状况。给您安利下CHROME<br />
                                5.若需要给上传图片添加标签，请先勾选再上传；视频不支持标签<br />
                                6.图片文件名中不建议含有中文，否则会造成部分功能失效<br />
                            </div>
                        </div>
                        <div style="display: flex;flex-wrap: wrap;padding:8px 15px">
                            <div v-for="(item, index) in filelist" :key="index"
                                style="margin:5px;width: 120px;border: 1px solid #eeeeee;">
                                <img :src="item.url" style="width:120px;height: 120px;object-fit: contain;" />
                                <div style="width:120px;height: 20px;">
                                    <el-progress color="#ec652c" text-color="#ffffff" :text-inside="true" :stroke-width="20"
                                        :percentage="Math.round(item.percentage)"></el-progress>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-col>

            </el-row>
        </div>
        <el-dialog title="新增标签" :visible.sync="biaoqianvisible" width="30%" :before-close="handleClose">
            <el-input v-model="biaoqianname" placeholder="请输入标签名称" size="small"></el-input>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose" size="small">取 消</el-button>
                <el-button type="primary" @click="tianjiabiaoqian" size="small">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog :title="shuiyintitle" :visible.sync="logovisible" width="1000px" :before-close="handleClose">
            <div>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <div style="font-weight: 600;margin-bottom: 5px;">
                            预览效果
                        </div>
                        <div style="position: relative;height:313px;">
                            <img src="../../assets/beijing.jpeg" style="width: 100%;" />
                            <img :src="logosrc"
                                :style="{ position: 'absolute', top: top, left: left, right: right, bottom: bottom, width: width, opacity: Number(toumingdu / 100), transform: transform }" />
                        </div>

                    </el-col>
                    <el-col :span="12">
                        <div style="font-weight: 600;margin-bottom: 5px;">
                            <span>上传水印</span>
                        </div>
                        <div style="display: flex;">
                            <el-upload class="upload-demo" action="https://interface.luchuaner.com/uploadlogo"
                                :show-file-list="false" :on-success="handleAvatarSuccess" accept=".jpg,.png,.jpeg">
                                <el-button size="mini" type="primary">点击上传</el-button>
                            </el-upload>
                            <div style="width:120px;min-height: 80px;margin-left:20px;display: flex;justify-content: center;align-items: center;background: #efefef;
    background-image: linear-gradient(90deg,rgba(0,0,0,.1) 50%,transparent 0),linear-gradient(rgba(0,0,0,.1) 50%,transparent 0);
    background-size: 10px 10px;">
                                <img :src="imageUrl" v-if="imageUrl != ''" style="width:100px;" />
                            </div>

                        </div>
                        <div style="display: flex;margin-top:10px;">

                            <div style="font-weight: 600;margin-bottom: 5px;margin-right: 40px;">
                                <span>水印位置</span>
                            </div>
                            <div style="margin-top:5px">
                                <el-radio-group v-model="weizhi">
                                    <div style="width:150px;display: flex;justify-content: space-around;height:50px;">
                                        <el-radio label="nw">&nbsp;</el-radio>
                                        <el-radio label="north">&nbsp;</el-radio>
                                        <el-radio label="ne">&nbsp;</el-radio>
                                    </div>
                                    <div style="width:150px;display: flex;justify-content: space-around;height:50px;">
                                        <el-radio label="west">&nbsp;</el-radio>
                                        <el-radio label="center">&nbsp;</el-radio>
                                        <el-radio label="east">&nbsp;</el-radio>
                                    </div>
                                    <div style="width:150px;display: flex;justify-content: space-around;height:10px;">
                                        <el-radio label="sw">&nbsp;</el-radio>
                                        <el-radio label="south">&nbsp;</el-radio>
                                        <el-radio label="se">&nbsp;</el-radio>
                                    </div>
                                </el-radio-group>
                            </div>
                        </div>
                        <div style="display: flex;margin-top:10px" class="sycs">

                            <div style="font-weight: 600;margin-bottom: 5px;margin-right: 40px;margin-top:10px">
                                <span>水印参数</span>
                            </div>
                            <div style="margin-top:5px;display: flex;">
                                <div style="line-height: 38px;width:60px;font-size: 12px;font-weight: 600;">
                                    <div>
                                        大小：
                                    </div>
                                    <div>
                                        透明度：
                                    </div>
                                    <div v-if="weizhi != 'center' && weizhi != 'north' && weizhi != 'south'">
                                        X边距：
                                    </div>
                                    <div v-if="weizhi != 'center' && weizhi != 'east' && weizhi != 'west'">
                                        Y边距：
                                    </div>
                                </div>
                                <div>
                                    <div style="width:300px;">
                                        <el-slider v-model="daxiao" input-size="mini" show-input>
                                        </el-slider>
                                    </div>
                                    <div>
                                        <el-slider v-model="toumingdu" input-size="mini" show-input>
                                        </el-slider>
                                    </div>
                                    <div v-if="weizhi != 'center' && weizhi != 'north' && weizhi != 'south'">
                                        <el-slider v-model="xbianju" input-size="mini" show-input>
                                        </el-slider>
                                    </div>
                                    <div v-if="weizhi != 'center' && weizhi != 'east' && weizhi != 'west'">
                                        <el-slider v-model="ybianju" input-size="mini" show-input>
                                        </el-slider>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose" size="small">取 消</el-button>
                <el-button type="primary" @click="tianjiashuiyin" size="small" v-if="shuiyintitle == '新增水印'">确 定</el-button>
                <el-button type="primary" @click="gengxinshuiyin" size="small" v-else>保存</el-button>
            </span>
        </el-dialog>
        <el-dialog :show-close="false" :close-on-click-modal="false" title="图片上传中" :visible.sync="picupvisible" width="30%">
            <div>
                <div class="progress" style="margin-left:10px;font-size: 12px;color:#000000">共{{
                    selpicnum }}张图片,上传中：
                    <el-progress style="margin-top:10px" :stroke-width="24" :percentage="picprogress" status="success"
                        :text-inside="true"></el-progress>
                </div>
            </div>
        </el-dialog>
        <!-- <vuedraggable class="wrapper" v-model="list">
    <transition-group >
      <div v-for="item in list" :key="item" class="item">{{item}}</div>
    </transition-group>
  </vuedraggable> -->
    </div>
</div>
</template>

<script>
import { huodezuzhaoxinxi, tianjiabiaoqian, huodebiaoqian, gengxinbiaoqian, tianjiashuiyin, getshuiyin, gengxinshuiyin } from "@/api/api";
import vuedraggable from 'vuedraggable';
import uploadvideo from '../../components/Uploadvideo.vue'
export default {
    components: {
        vuedraggable,
        uploadvideo
    },
    data() {
        return {
            zuzhaoid: '',
            zuzhaotitle: '',
            in_id: '',
            biaoqianvisible: false,
            biaoqianname: '',
            list: [1, 2, 34, 4, 54, 5],
            biaoqianlist: [],
            logovisible: false,
            logosrc: 'https://resources.luchuaner.com/newlogobai.png',
            top: '',
            left: '',
            bottom: '0px',
            right: '0px',
            imageUrl: 'https://resources.luchuaner.com/newlogobai.png',
            weizhi: 'se',
            toumingdu: 100,
            daxiao: 100,
            width: '136px',
            xbianju: 0,
            ybianju: 0,
            transform: '',
            logo_name: '',
            shuiyinlist: [],
            shuiyintitle: '新增水印',
            xiugaiid: '',
            filelist: [],
            selbiaoqian: [],
            share_label_id: '',
            selpicnum: 0,
            reapicnum: 0,
            picprogress: 0,
            picupvisible: false,
            secretkey: '',
            zuzhaoobj:{}

        }
    },
    props: {
    showfxlj: Function
  },
    watch: {

        biaoqianlist(val1, val2) {
            console.log(val1)
            if (val1.length == val2.length) {
                val1.forEach((element, index) => {
                    element.quanzhong = index + 2
                    this.gengxinbiaoqian(element, 2)
                });
            }

        },
        daxiao(val1, val2) {
            let img = new Image()
            img.src = this.logosrc;
            let that = this
            img.onload = function () {
                let width = Math.round(Number(img.width) * Number(that.daxiao) / 100 / 3.4)
                that.width = width + 'px'
            };
        },
        weizhi(val1, val2) {
            if (val1 == 'se') {
                this.top = ''
                this.left = ''
                this.bottom = Math.round(this.ybianju / 3.4) + 'px'
                this.right = Math.round(this.xbianju / 3.4) + 'px'
                this.transform = ''
            }
            if (val1 == 'sw') {
                this.top = ''
                this.left = Math.round(this.xbianju / 3.4) + 'px'
                this.bottom = Math.round(this.ybianju / 3.4) + 'px'
                this.right = ''
                this.transform = ''
            }
            if (val1 == 'nw') {
                this.top = Math.round(this.ybianju / 3.4) + 'px'
                this.left = Math.round(this.xbianju / 3.4) + 'px'
                this.bottom = ''
                this.right = ''
                this.transform = ''
            }
            if (val1 == 'ne') {
                this.top = Math.round(this.ybianju / 3.4) + 'px'
                this.left = ''
                this.bottom = ''
                this.right = Math.round(this.xbianju / 3.4) + 'px'
                this.transform = ''
            }
            if (val1 == 'center') {
                this.top = '50%'
                this.left = '50%'
                this.bottom = ''
                this.right = ''
                this.transform = 'translate(-50%, -50%)';
            }
            if (val1 == 'north') {
                this.top = Math.round(this.ybianju / 3.4) + 'px'
                this.left = '50%'
                this.bottom = ''
                this.right = ''
                this.transform = 'translate(-50%, 0%)';
            }
            if (val1 == 'south') {
                this.top = ''
                this.left = '50%'
                this.bottom = Math.round(this.ybianju / 3.4) + 'px'
                this.right = ''
                this.transform = 'translate(-50%, 0%)';
            }
            if (val1 == 'west') {
                this.top = '50%'
                this.left = Math.round(this.xbianju / 3.4) + 'px'
                this.bottom = ''
                this.right = ''
                this.transform = 'translate(0%, -50%)';
            }
            if (val1 == 'east') {
                this.top = '50%'
                this.left = ''
                this.bottom = ''
                this.right = Math.round(this.xbianju / 3.4) + 'px'
                this.transform = 'translate(0%, -50%)';
            }
        },
        xbianju(val1) {
            if (this.weizhi == 'se') {
                this.top = ''
                this.left = ''
                this.bottom = Math.round(this.ybianju / 3.4) + 'px'
                this.right = Math.round(this.xbianju / 3.4) + 'px'
                this.transform = ''
            }
            if (this.weizhi == 'sw') {
                this.top = ''
                this.left = Math.round(this.xbianju / 3.4) + 'px'
                this.bottom = Math.round(this.ybianju / 3.4) + 'px'
                this.right = ''
                this.transform = ''
            }
            if (this.weizhi == 'nw') {
                this.top = Math.round(this.ybianju / 3.4) + 'px'
                this.left = Math.round(this.xbianju / 3.4) + 'px'
                this.bottom = ''
                this.right = ''
                this.transform = ''
            }
            if (this.weizhi == 'ne') {
                this.top = Math.round(this.ybianju / 3.4) + 'px'
                this.left = ''
                this.bottom = ''
                this.right = Math.round(this.xbianju / 3.4) + 'px'
                this.transform = ''
            }
            if (this.weizhi == 'center') {
                this.top = '50%'
                this.left = '50%'
                this.bottom = ''
                this.right = ''
                this.transform = 'translate(-50%, -50%)';
            }
            if (this.weizhi == 'north') {
                this.top = Math.round(this.ybianju / 3.4) + 'px'
                this.left = '50%'
                this.bottom = ''
                this.right = ''
                this.transform = 'translate(-50%, 0%)';
            }
            if (this.weizhi == 'south') {
                this.top = ''
                this.left = '50%'
                this.bottom = Math.round(this.ybianju / 3.4) + 'px'
                this.right = ''
                this.transform = 'translate(-50%, 0%)';
            }
            if (this.weizhi == 'west') {
                this.top = '50%'
                this.left = Math.round(this.xbianju / 3.4) + 'px'
                this.bottom = ''
                this.right = ''
                this.transform = 'translate(0%, -50%)';
            }
            if (this.weizhi == 'east') {
                this.top = '50%'
                this.left = ''
                this.bottom = ''
                this.right = Math.round(this.xbianju / 3.4) + 'px'
                this.transform = 'translate(0%, -50%)';
            }
        },
        ybianju(val1) {
            if (this.weizhi == 'se') {
                this.top = ''
                this.left = ''
                this.bottom = Math.round(this.ybianju / 3.4) + 'px'
                this.right = Math.round(this.xbianju / 3.4) + 'px'
                this.transform = ''
            }
            if (this.weizhi == 'sw') {
                this.top = ''
                this.left = Math.round(this.xbianju / 3.4) + 'px'
                this.bottom = Math.round(this.ybianju / 3.4) + 'px'
                this.right = ''
                this.transform = ''
            }
            if (this.weizhi == 'nw') {
                this.top = Math.round(this.ybianju / 3.4) + 'px'
                this.left = Math.round(this.xbianju / 3.4) + 'px'
                this.bottom = ''
                this.right = ''
                this.transform = ''
            }
            if (this.weizhi == 'ne') {
                this.top = Math.round(this.ybianju / 3.4) + 'px'
                this.left = ''
                this.bottom = ''
                this.right = Math.round(this.xbianju / 3.4) + 'px'
                this.transform = ''
            }
            if (this.weizhi == 'center') {
                this.top = '50%'
                this.left = '50%'
                this.bottom = ''
                this.right = ''
                this.transform = 'translate(-50%, -50%)';
            }
            if (this.weizhi == 'north') {
                this.top = Math.round(this.ybianju / 3.4) + 'px'
                this.left = '50%'
                this.bottom = ''
                this.right = ''
                this.transform = 'translate(-50%, 0%)';
            }
            if (this.weizhi == 'south') {
                this.top = ''
                this.left = '50%'
                this.bottom = Math.round(this.ybianju / 3.4) + 'px'
                this.right = ''
                this.transform = 'translate(-50%, 0%)';
            }
            if (this.weizhi == 'west') {
                this.top = '50%'
                this.left = Math.round(this.xbianju / 3.4) + 'px'
                this.bottom = ''
                this.right = ''
                this.transform = 'translate(0%, -50%)';
            }
            if (this.weizhi == 'east') {
                this.top = '50%'
                this.left = ''
                this.bottom = ''
                this.right = Math.round(this.xbianju / 3.4) + 'px'
                this.transform = 'translate(0%, -50%)';
            }
        }
    },
    created() {
        let query = this.$route.query
        console.log(query)
        this.secretkey = query.key
        this.huodezuzhaoxinxi(query.key)    
        document.title='后台|协作续传'
    },
    methods: {
        fanhui() {
            window.history.back();
        },
        xzbiaoqian(val) {
            this.share_label_id = val.join(',')
        },
        handleChange(file, fileList) {
            file.url = URL.createObjectURL(file.raw);
            this.filelist = fileList
            console.log(fileList)
            this.selpicnum = this.filelist.length           
            console.log(this.selpicnum)

        },
        handleAvatarSuccesstp(res, file) {
            //  this.imageUrl = URL.createObjectURL(file.raw);
            this.reapicnum = this.reapicnum + 1
            //console.log(this.reapicnum)
            this.picprogress = Math.ceil(this.reapicnum / this.selpicnum * 100)
            // console.log(this.picprogress)
            if (this.reapicnum == this.selpicnum) {
                this.picupvisible = false
                //this.reapicnum = 0
                //this.selpicnum = 0
                this.picprogress = 0
                this.$notify({
                    title: '上传图片',
                    message: '图片上传完毕',
                    type: 'success'
                });
            }
        },
        handlePreview(file) {
            console.log(file)
        },
        beforeAvatarUpload(file) {
          
            const isLt2M = file.size / 1024 / 1024 < 15;

         
            if (!isLt2M) {
                this.$message.error('上传图片大小不能超过 15MB!');
            }
            if (isLt2M) {
                this.picupvisible = true
            }
            return  isLt2M;
        },
        async shanchushuiyin(item) {
            await gengxinshuiyin({
                is_deleted: 1,
                is_enabled: 2,
                id: item.id
            }).then(res => {
                this.$notify({
                    title: '删除水印',
                    message: '删除成功',
                    type: 'success'
                });
                //  this.logovisible = false
                this.getshuiyin()
            })
        },
        async gengxinshuiyin() {
            await gengxinshuiyin({
                weizhi: this.weizhi,
                daxiao: this.daxiao,
                toumingdu: this.toumingdu,
                xbianju: this.xbianju,
                ybianju: this.ybianju,
                logo_name: this.logo_name,
                id: this.xiugaiid
            }).then(res => {
                this.$notify({
                    title: '修改水印',
                    message: '修改成功',
                    type: 'success'
                });
                this.logovisible = false
                this.getshuiyin()
            })
        },
        xiugaishuiyin(item) {
            console.log(item)
            this.shuiyintitle = '修改水印'
            this.logovisible = true
            this.logosrc = this.IMAGEPATH + item.logo_name
            this.imageUrl = this.IMAGEPATH + item.logo_name
            this.weizhi = item.weizhi
            this.toumingdu = item.toumingdu
            this.daxiao = Number(item.daxiao)
            this.xbianju = Number(item.xbianju)
            this.ybianju = Number(item.ybianju)
            this.logo_name = item.logo_name
            this.xiugaiid = item.id
        },
        filterweizhi(item) {
            if (item == 'se') {
                return '右下'
            }
            if (item == 'ne') {
                return '右上'
            }
            if (item == 'sw') {
                return '左下'
            }
            if (item == 'nw') {
                return '左上'
            }
            if (item == 'south') {
                return '中下'
            }
            if (item == 'north') {
                return '中上'
            }
            if (item == 'west') {
                return '中左'
            }
            if (item == 'east') {
                return '中右'
            }
            if (item == 'center') {
                return '中间'
            }

        },
        async getshuiyin() {
            await getshuiyin({
                collection_id: this.zuzhaoid,
            }).then(res => {
                this.shuiyinlist = res.data.data
            })
        },
        async tianjiashuiyin() {
            if (this.logo_name == '') {
                this.$notify.error({
                    title: '上传水印',
                    message: '请上传水印'
                });
            } else {
                await tianjiashuiyin({
                    in_id: this.in_id,
                    collection_id: this.zuzhaoid,
                    weizhi: this.weizhi,
                    daxiao: this.daxiao,
                    toumingdu: this.toumingdu,
                    xbianju: this.xbianju,
                    ybianju: this.ybianju,
                    logo_name: this.logo_name
                }).then(res => {
                    this.$notify({
                        title: '上传水印',
                        message: '上传成功',
                        type: 'success'
                    });
                    this.logovisible = false
                    this.getshuiyin()
                })
            }

        },
        handleAvatarSuccess(res, file) {

            let img = new Image()
            img.src = res.data;
            let that = this
            img.onload = function () {
                console.log(img.width)
                that.width = Math.round(img.width * that.daxiao / 100 / 3.4) + 'px'
                that.imageUrl = URL.createObjectURL(file.raw);
                that.logosrc = URL.createObjectURL(file.raw);
            };
            this.logo_name = res.logo_name

        },
        xianshilogo() {
            this.logovisible = true
            this.shuiyintitle = '新增水印'
            this.logosrc = 'https://resources.luchuaner.com/newlogobai.png'
            this.top = ''
            this.left = ''
            this.bottom = '0px'
            this.right = '0px'
            this.imageUrl = 'https://resources.luchuaner.com/newlogobai.png'
            this.weizhi = 'se'
            this.toumingdu = 100
            this.daxiao = 100
            this.xbianju = 0
            this.ybianju = 0
            this.transform = ''
            this.logo_name = ''
        },
        async gengxinbiaoqian(item, is_deleted) {
            await gengxinbiaoqian({
                id: item.id,
                labelname: item.labelname,
                is_deleted: is_deleted,
                quanzhong: item.quanzhong
            })
        },
        async baocun(item, is_deleted) {
            await gengxinbiaoqian({
                id: item.id,
                labelname: item.labelname,
                is_deleted: is_deleted,
                quanzhong: item.quanzhong
            }).then(res => {
                this.$notify({
                    title: '编辑标签',
                    message: '编辑成功',
                    type: 'success'
                });
                this.huodebiaoqian()
            })
        },
        async tianjiabiaoqian() {
            if (this.biaoqianname == '') {
                this.$notify.error({
                    title: '添加标签',
                    message: '请填写标签名称'
                });
            } else {
                await tianjiabiaoqian({
                    collection_id: this.zuzhaoid,
                    in_id: this.in_id,
                    labelname: this.biaoqianname
                }).then(res => {
                    this.$notify({
                        title: '添加标签',
                        message: '添加成功',
                        type: 'success'
                    });
                    this.biaoqianname = ''
                    this.biaoqianvisible = false
                    this.huodebiaoqian()
                })
            }

        },
        async huodebiaoqian() {
            await huodebiaoqian({
                collection_id: this.zuzhaoid,
            }).then(res => {
                this.biaoqianlist = res.data.data
            })
        },
        xianshibiaoqian() {
            this.biaoqianvisible = true
        },
        handleClose() {
            this.biaoqianvisible = false
            this.logovisible = false
        },
        async huodezuzhaoxinxi(key) {
            await huodezuzhaoxinxi({
                secretkey: key
            }).then(res => {
                this.zuzhaoid = res.data.data.id
                console.log(this.zuzhaoid)
                this.zuzhaotitle = res.data.data.title
                this.zuzhaoobj=res.data.data
                this.in_id = res.data.data.in_id
                console.log(this.in_id)
                if(res.data.data.is_shareup == 2){
                    window.location.href='/'
                }
                this.huodebiaoqian()
                this.getshuiyin()
            })
        },
    }
}
</script>

<style>
.sycs .el-slider__input {
    width: 100px;
}

.sycs .el-slider__runway.show-input {
    margin-right: 130px;
    width: auto;
}

.sycs .el-radio__inner::after {
    background-color: #ec652c;

}

.shuiyintab {
    border-spacing: 0px;
    line-height: 30px;
}

.shuiyintab th {
    border-bottom: 1px solid #eeeeee;
}

.shuiyintab td {
    border-bottom: 1px solid #eeeeee;
}

.el-progress-bar__outer {

    border-radius: 0px !important;
}

.el-progress-bar__inner {
    border-radius: 0px !important;
}

</style>